import { StepStatus } from "@app/analytics/onboarding/types";

import { Container, StepIcon } from "./styles";

interface ProgressIndicatorProps {
  active?: boolean;
  status: StepStatus;
  nested?: boolean;
}

const ProgressIndicator = ({
  status,
  active = false,
  nested,
}: ProgressIndicatorProps) => {
  return (
    <Container status={status} nested={nested} active={active}>
      <StepIcon status={status} nested={nested} active={active} />
    </Container>
  );
};

export default ProgressIndicator;
